// @ts-ignore
export const quickCatchment = (state) => state.quickCatchment;

// @ts-ignore
export const all = (state) => state.all;
// @ts-ignore
export const layers = (state) => {
  const props: any[] = [];
  state.layers.forEach((layer: any) => {
    const properties = layer.getProperties();
    props.push({
      layer,
      props: properties,
    });
  });
  return props;
};
// @ts-ignore
export const visibility = (state) => state.activeLayer ? state.activeLayer.getVisible() : true;

// @ts-ignore
export const activeLayerName = (state) => state.activeLayer ? state.activeLayer.getProperties().name : '';
// @ts-ignore
export const ageMicroraster = (state) => state.ageMicroraster;
// @ts-ignore
export const buyingPowerMicroraster = (state) => state.buyingPowerMicroraster;
// @ts-ignore
export const competitors = (state) => state.competitors;
// @ts-ignore
export const microraster = (state) => state.microraster;
// @ts-ignore
export const addresses = (state) => state.addresses;
// @ts-ignore
export const infoDialog = (state) => state.infoDialog;
// @ts-ignore
export const welcomeDialog = (state) => state.welcomeDialog;

